import { Favorite, FavoriteBorder } from '@tunasong/icons'
import { type FC } from 'react'
import { IconButton, type IconButtonProps } from '../primitives/index.js'
import type { FavoriteControlProps } from './favorite-props.js'
import { useFavorites } from './favorites.hook.js'

type FavoriteIconProps = FavoriteControlProps<IconButtonProps>

export const FavoriteIcon: FC<FavoriteIconProps> = props => {
  const { onClick, entity, ...restProps } = props

  const { isFavorite, toggleFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const favorite = isFavorite(entity)
  const FavoriteIcon = favorite ? Favorite : FavoriteBorder

  return (
    <IconButton
      {...restProps}
      color={favorite ? 'error' : 'inherit'}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        const template = getFavoriteTemplateFromEntity(entity)
        toggleFavorite(template)
        if (onClick) {
          onClick(ev)
        }
      }}
      aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
      style={{ flex: '0 0 auto', ...restProps.style }}
    >
      <FavoriteIcon />
    </IconButton>
  )
}

export default FavoriteIcon
